<template>
  <div>
    <section class="blockElement banner Cmp_guide2 pb-0">
      <div class="container" align="center">
        <div class="banner_text text-center">
          <h1 class="m-0">
            Step into the<span> future</span><br />
            of investing!
          </h1>
        </div>
        <img class="img-fluid lazy" width="777" height="418" src="../../../../static/website/images/mutual-fund-header.svg" alt="open_account_image" title="open account image"/>
      </div>
    </section>
    <!--Section-->
    <section class="blockElement debt-fund pt-4 pb-2">
      <div class="container">
        <div class="row dFund">
          <div class="col col1">
            <div class="d-flex fundArea">
              <img class="img-fluid" height="13" width="13" alt="Icon" title="check image" src="../../../../static/website/images/checkmark.svg"/>
              <p>Tax Saving</p>
            </div>
          </div>
          <div class="col col2">
            <div class="d-flex fundArea">
              <img class="img-fluid" height="13" width="13" alt="Icon" title="check image" src="../../../../static/website/images/checkmark.svg"/>
              <p>SIP Eligible</p>
            </div>
          </div>
          <div class="col col3">
            <div class="d-flex fundArea">
              <img class="img-fluid" height="13" width="13" alt="Icon" title="check image" src="../../../../static/website/images/checkmark.svg"/>
              <p>Debt Funds</p>
            </div>
          </div>
          <div class="col col4">
            <div class="d-flex fundArea">
              <img class="img-fluid" height="13" width="13" alt="Icon" title="check image" src="../../../../static/website/images/checkmark.svg"/>
              <p>Balance Funds</p>
            </div>
          </div>
          <div class="col col5">
            <div class="d-flex fundArea">
              <img class="img-fluid" height="13" width="13" alt="Icon" title="check image" src="../../../../static/website/images/checkmark.svg"/>
              <p>Liquid Funds</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Section-->
    <section class="blockElement aboutUs pt-4">
      <div class="container">
        <div class="row text-center justify-content-center">
          <div class="col-12 col-sm-11">
            <div class="bottom-shadow whiteBoard">
              <p>
                Lower your investing risks by letting a mutual fund work for
                you. Use our SMART portal to choose the right mutual funds for
                your portfolio. The portal offers tools to research, compare and
                invest in mutual funds all in one place.
              </p>
              <div class="customBtn-bt d-inline-block">
                <a
                  class="fin_btn darkBG"
                  href="https://www.shoonya.com/mutual-funds"
                  target="_blank"
                  >Invest in Mutual Funds</a
                >
                <div class="animationArrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 209 117"
                    width="190"
                    height="100"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <g>
                      <g
                        style="display: block"
                        transform="matrix(0.6139630675315857,0.26823386549949646,-0.26823386549949646,0.6139630675315857,120.114990234375,45.516510009765625)"
                        opacity="1"
                      >
                        <g opacity="1" transform="matrix(1.5,0,0,1.5,0,0)">
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            fill-opacity="0"
                            stroke="rgb(51,51,51)"
                            stroke-opacity="1"
                            stroke-width="6"
                            d=" M-87.4000015258789,31.354999542236328 C-66.88099670410156,35.305999755859375 -37.04100036621094,39.92399978637695 -16.517000198364258,37.29199981689453 C40.516998291015625,29.979000091552734 34.388999938964844,-17.67099952697754 34.388999938964844,-17.67099952697754 C34.388999938964844,-17.67099952697754 33.35200119018555,-40.87300109863281 7.7779998779296875,-33.757999420166016 C-16.81399917602539,-26.91699981689453 -0.3619999885559082,4.229000091552734 -0.3619999885559082,4.229000091552734 C-0.3619999885559082,4.229000091552734 17.44700050354004,36.60599899291992 54.81999969482422,34.165000915527344 C71.677001953125,33.06399917602539 85.39600372314453,26.06999969482422 96.75499725341797,14.918999671936035"
                            class=""
                          ></path>
                        </g>
                      </g>

                      <g
                        style="display: block"
                        transform="matrix(-0.2974865436553955,0.6003347039222717,0.6003347039222717,0.2974865436553955,23.29077911376953,25.141700744628906)"
                        opacity="1"
                      >
                        <g opacity="1" transform="matrix(1.5,0,0,1.5,0,0)">
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            fill-opacity="0"
                            stroke="rgb(51,51,51)"
                            stroke-opacity="1"
                            stroke-width="6"
                            d=" M1.8020000457763672,21.783000946044922 C1.8020000457763672,21.783000946044922 9.711999893188477,3.072999954223633 9.711999893188477,3.072999954223633 C9.711999893188477,3.072999954223633 23.98200035095215,17.542999267578125 23.98200035095215,17.542999267578125"
                            class=""
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div class="cta blob part" data-num="1">
              <img
                src="../../../../static/website/images/footer-blob1.svg"
                alt="Icon"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Section-->
    <!--Section-->
    <section class="blockElement hft mg-page">
      <div class="container">
        <div class="head-title text-center">
          <h2>Why Mutual <span>Funds</span></h2>
          <p>
            Investing in mutual funds offers benefits you won't get from
            investing in other avenues.
          </p>
        </div>
        <div class="row">
          <div class="col-12 col-md-3 text-center fxOne">
            <div class="shadowWhite">
              <span><img class="img-fluid" width="80" height="70" alt="Diversification" title="Diversification image" src="../../../../static/website/images/smart.svg"/></span>
              <h3><strong>Built-in </strong> Diversification</h3>
              <div class="bottomAres">
                <p>
                  One mutual fund can invest in hundreds of different stocks,
                  bonds and securities at one time, giving you access to a
                  diversified portfolio.
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3 text-center fxOne">
            <div class="shadowWhite">
              <span>
                <img class="img-fluid" width="80" height="70" alt="Commissions-no" title="Commissions-no image" src="../../../../static/website/images/ftx-icon-2.svg"/>
              </span>
              <h3><strong>No </strong> Commissions</h3>
              <div class="bottomAres">
                <p>
                    Shoonya offers zero-commission investing; therefore, you pay no commissions to buy, sell or switch mutual funds.
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3 text-center fxOne">
            <div class="shadowWhite">
              <span>
                <img class="img-fluid" width="80" height="70" alt="Management" title="Management image" src="../../../../static/website/images/ftx-icon-3.svg"/>
              </span>
              <h3><strong>Professional </strong> Management</h3>
              <div class="bottomAres">
                <p>
                  Mutual funds are managed by experts and you don't have to keep
                  track of every security your mutual fund owns.
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3 text-center fxOne">
            <div class="shadowWhite">
              <span>
                <img class="img-fluid" width="80" height="70" alt="Convenience" title="Convenience image"  src="../../../../static/website/images/ftx-icon-3.svg"/>
              </span>
              <h3><strong>Convenience</strong> &nbsp;</h3>
              <div class="bottomAres">
                <p>
                  You can buy and sell mutual fund shares online or by phone
                  through our Mutual Funds portal
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="blockElement edge-texture darkBG">
      <div class="container">
        <div class="head-title text-center">
          <h2>Mutual Fund <span>Tools</span></h2>
        </div>
        <div
          class="row text-left mutualfundtoolSec justify-content-center mb-5"
        >
          <div class="col-12 col-md-6">
            <div class="customBtn-bt border-bottom mb-4">
              <h4>Simulate</h4>
              <p>
                Create multiple portfolios and simulate your existing
                investments
              </p>
            </div>
            <div class="customBtn-bt border-bottom mb-4">
              <h4>Compare</h4>
              <p>Add and compare various Funds along with historical charts</p>
            </div>
            <div class="customBtn-bt border-bottom mb-4">
              <h4>Analyze</h4>
              <p>
                Evaluate from over 30 parameters such as NAV, Returns, Risk, etc
              </p>
            </div>
            <div class="customBtn-bt">
              <h4>Invest</h4>
              <p>You can invest on our web and mobile app anytime</p>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="mutualfund_Slider">
              <div
                id="carouselExampleSlidesOnly"
                class="carousel slide"
                data-ride="carousel"
              >
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <img class="img-fluid" width="540" height="271" alt="slider-img-1" title="slider image 1" src="../../../../static/website/images/mf_slider3.webp" />
                  </div>
                  <div class="carousel-item">
                    <img class="img-fluid" width="540" height="271" alt="slider-img-2" title="slider image 2" src="../../../../static/website/images/mf_slider1.webp"/>
                  </div>
                  <!-- <div class="carousel-item">
                                        <img src="../../../../static/website/images/mf_slider2.webp" alt="">
                                    </div> -->
                  <div class="carousel-item">
                    <img class="img-fluid" width="540" height="271" alt="slider-img-3" title="slider image 3" src="../../../../static/website/images/mf_slider4.webp"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="customBtn-bt text-center w-100">
          <a
            class="fin_btn brownBG"
            href="https://mf.shoonya.com/simulate"
            target="_blank"
            >Try Now</a
          >
        </div>
      </div>
    </section>
    <section
      class="blockElement prdctBoxOuter yourGoals getAccount noneGetAccount"
    >
      <div class="container">
        <div class="head-title text-center">
          <h2>What are your <span> Goals ?</span></h2>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-md-10">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="prdctBox">
                  <div class="desc text-left red-p">
                    <h4><span>Tax </span> Saving Schemes</h4>
                    <p>
                      Invest in ELSS and save up to 46,350 in taxes as well as
                      earn tax free market linked returns.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="prdctBox">
                  <div class="desc text-left red-p">
                    <h4><span>Long </span> Term Saving Schemes</h4>
                    <p>
                        Secure your future financial wellness with the help of Shoonya’s artificial intelligence monitoring.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="prdctBox">
                  <div class="desc text-left red-p">
                    <h4><span>Short </span> Term Saving Schemes</h4>
                    <p>
                      An Ideal Investment venue for your idle cash & earn up to
                      7-8% with no lock-in restrictions.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="prdctBox">
                  <div class="desc text-left red-p">
                    <h4><span>Analyze Your </span> Portfolio</h4>
                    <p>
                      A complete set of research & analysis tools for your
                      investment & make informed decision.
                    </p>
                  </div>
                </div>
              </div>
              <div class="text-center w-100">
                <div class="customBtn-bt d-inline-block">
                  <a
                    class="fin_btn darkBG"
                    href="https://mf.shoonya.com/"
                    target="_blank"
                    >Invest Now</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="blockElement whiteBG areaAround mobSS pb-5 mt-top">
      <div class="container">
        <div class="head-title text-center">
          <h2>Our <span> Fund</span> Partners</h2>
        </div>
        <div class="row justify-content-center align-items-center">
          <div class="col-12 col-sm-2 ctLogo">
            <a href="#"
              ><img class="img-fluid" width="160" height="43" title="logo-image"
                src="../../../../static/website/images/fund-logo-1.webp"
                alt="Client Logo"
              />
            </a>
          </div>
          <div class="col-12 col-sm-2 ctLogo">
            <a href="#"
              ><img class="img-fluid" width="160" height="43" title="logo-image"
                src="../../../../static/website/images/fund-logo-2.webp"
                alt="Client Logo"
              />
            </a>
          </div>
          <div class="col-12 col-sm-2 ctLogo">
            <a href="#"
              ><img class="img-fluid" width="160" height="20" title="logo-image"
                src="../../../../static/website/images/fund-logo-3.webp"
                alt="Client Logo"
              />
            </a>
          </div>
          <div class="col-12 col-sm-2 ctLogo">
            <a href="#"
              ><img class="img-fluid" width="160" height="43" title="logo-image"
                src="../../../../static/website/images/fund-logo-4.webp"
                alt="Client Logo"
              />
            </a>
          </div>
          <div class="col-12 col-sm-2 ctLogo">
            <a href="#"
              ><img class="img-fluid" width="160" height="43" title="logo-image"
                src="../../../../static/website/images/fund-logo-5.webp"
                alt="Client Logo"
              />
            </a>
          </div>
          <div class="col-12 col-sm-2 ctLogo">
            <a href="#"
              ><img class="img-fluid" width="160" height="43" title="logo-image"
                src="../../../../static/website/images/fund-logo-6.webp"
                alt="Client Logo"
              />
            </a>
          </div>
          <div class="col-12 col-sm-2 ctLogo">
            <a href="#"
              ><img class="img-fluid" width="160" height="43" title="logo-image"
                src="../../../../static/website/images/fund-logo-7.webp"
                alt="Client Logo"
              />
            </a>
          </div>
          <div class="col-12 col-sm-2 ctLogo">
            <a href="#"
              ><img class="img-fluid" width="160" height="43" title="logo-image"
                src="../../../../static/website/images/fund-logo-8.webp"
                alt="Client Logo"
              />
            </a>
          </div>
          <div class="col-12 col-sm-2 ctLogo">
            <a href="#"
              ><img class="img-fluid" width="160" height="43" title="logo-image"
                src="../../../../static/website/images/fund-logo-9.webp"
                alt="Client Logo"
              /> 
            </a>
          </div>
        </div>
        <div class="text-center">
          <div class="andmore d-inline-block mt-3">And More..</div>
        </div>
      </div>
      <app-seo></app-seo>
    </section>
  </div>
</template>
<script>
import SEO from "../shared/SEO";
import VueFaqAccordion from "vue-faq-accordion";
import { CheckIcon } from "vue-feather-icons";
export default {
  name: "Mutual Funds",
  data() {
    return {
      prismRegisterPath: process.env.PRISM_REGISTER,
      smartPortalLoginPath: process.env.SMARTPORTAL_LOGIN,
      mfScreenerPath: process.env.MF_SCREENER,
      sipCalculatorPath: process.env.SIP_CALCULATOR,
      simulatorPath: process.env.SIMULATOR,
      returnCalculatorPath: process.env.RETURN_CALCULATOR,
      smartPortalRegisterPath: process.env.SMARTPORTAL_REGISTER,
      tabs: [
        {
          name: "overview",
          displayName: "SMART",
        },
        {
          name: "about",
          displayName: "Backtest your Mutual Funds",
        },
        {
          name: "check",
          displayName: "Fund Monitoring",
        },
        {
          name: "fin",
          displayName: "Thematic Investment",
        },
      ],
      activeTabName: null,
    };
  },
  components: {
    VueFaqAccordion,
    appSeo: SEO,
    CheckIcon,
  },
  methods: {
    setActiveTabName(name) {
      this.activeTabName = name;
    },
  },
  computed: {},
  mounted() {
    this.activeTabName = this.tabs[0].name;
    window.scroll(0, 0);
  },
};
</script>






// WEBPACK FOOTER //
// src/components/website/products/mutual_funds.vue